/**
 * Logs a user out via Auth0 while storing a local flag to display context
 * after redirect (e.g., user not found, etc.).
 */
export const logoutWithFlag = (logoutFn, flagKey, flagValue) => {
  if (!logoutFn || !flagKey) {
    return;
  }

  localStorage.setItem(flagKey, flagValue);

  const returnUrl =
    process.env.REACT_APP_AUTH0_RETURN_URL || window.location.origin;

  return logoutFn({
    logoutParams: {
      returnTo: returnUrl,
    },
  }).then(() => {
    window.location.href = returnUrl;
  });
};

